import { paths, SchemaAttachFileRequestModel } from "@/api-types";
import createClient from "openapi-fetch";

const client = createClient<paths>({ baseUrl: import.meta.env.VITE_API_URL });

const resilientExecute = async <T>(fn: () => Promise<T>): Promise<T> => {
    while (true) {
        try {
            return await fn();
        } catch (e) {
            console.error(e);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }
};

export const getSession = async (sessionId: string) => {
    return await resilientExecute(() => client.GET(`/sessions/{sessionId}`, { params: { path: { sessionId } } }));
};

export const attachFile = async (sessionId: string, body: SchemaAttachFileRequestModel) => {
    return await resilientExecute(() =>
        client.POST(`/sessions/{sessionId}/files`, {
            params: { path: { sessionId } },
            body,
        })
    );
};

export const uploadChunk = async (blob: Blob, fileId: string, sessionId: string, cursor: number) => {
    console.log(`Uploading chunk of size ${blob.size} at cursor ${cursor}`);
    return await resilientExecute(() =>
        client.POST("/sessions/{sessionId}/files/{fileId}/parts/{cursor}", {
            params: {
                path: { fileId, sessionId, cursor },
            },
            body: {
                part: "part",
            },
            bodySerializer: () => {
                const body = new FormData();
                body.append("part", blob);
                return body;
            },
        })
    );
};

export const deleteFile = async (sessionId: string, fileId: string) => {
    return await resilientExecute(() =>
        client.DELETE("/sessions/{sessionId}/files/{fileId}", {
            params: {
                path: {
                    sessionId,
                    fileId,
                },
            },
        })
    );
};

export const finalizeSession = async (sessionId: string) => {
    return await resilientExecute(() =>
        client.POST("/sessions/{sessionId}/finalize", {
            params: {
                path: { sessionId },
            },
            body: new FormData() as any,
        })
    );
};
